import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SsoMsalComponent } from './sso-msal.component';

const routes: Routes = [{
  path: '',
  component: SsoMsalComponent,
},];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SsoMsalRoutingModule { }
